import script from "./categoriesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./categoriesTab.vue?vue&type=script&setup=true&lang=js"

import "./categoriesTab.vue?vue&type=style&index=0&id=f2b0b084&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b0b084"]])

export default __exports__